export enum ETripPlannerView {
  PLANNER_OVERVIEW = 'PLANNER_OVERVIEW',
  CITY_OVERVIEW = 'CITY_OVERVIEW',
  CITY_PREVIEW = 'CITY_PREVIEW',
  FLIGHTS_BOX = 'FLIGHTS_BOX',
  CAR_RENTAL_BOX = 'CAR_RENTAL_BOX',
  HOTEL_BOX = 'HOTEL_BOX',
}

export enum ETripCityInfoType {
  BOOKING,
  OCCASION_GENIUS,
  VIATOR,
  VOICE_GUIDE
}
